export default __webpack_public_path__ + "static/media/ripple.b4ffaf58.svg";